'use strict';

var isEmptyJQuery = require('./is-empty-jquery'),
    isObject = require('./is-object'),
    isEmptyObject = require('./is-empty-object');

/**
 * @param mixed
 * @returns {boolean}
 */
module.exports = function isEmpty(mixed) {
    if (isObject(mixed)) {
        //Controllo anche le ownProperties per mantenere la retrocompatibilità
        return isEmptyJQuery(mixed) || isEmptyObject(mixed, true);
    }

    return !mixed || mixed === 'null';
};
